import all from './all';
import allOptions from './allOptions';
import destroy from './destroy';
import store from './store';
import update from './update';
import show from './show';
import items from './items';
import counts from './counts';
import findBusiness from './findBusiness';
import ehfLookup from './ehfLookup';
import updateAddress from './updateAddress';
import bulkUpdate from './bulkUpdate';
import glnLookup from './glnLookup';
import sendCatalogue from './sendCatalogue';

export default {
  all,
  allOptions,
  destroy,
  store,
  update,
  show,
  items,
  counts,
  findBusiness,
  ehfLookup,
  updateAddress,
  bulkUpdate,
  glnLookup,
  sendCatalogue,
};



// WEBPACK FOOTER //
// ./src/app/services/client/index.js